// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1xlIu","question":"Question_question__1dNNW","description":"Question_description__3zU-Y"};